/**
 * ETML
 * @ De: Theo Bensaci
 * @ Date: 17:54 23.04.2023
 * @ Description: Page de loading, qui permette aussi de set up la game admin
 */


import "./index.css";
import React, {useEffect} from "react";
import GamePageManager from "../../utils/GamePageManager";
import GameAdmin from "../../GameClass/gameAdmin";
import api from "../../utils/api";

export default function GameLoading() {

    useEffect(()=>{
        let ga = new GameAdmin();
        // appel l'api -> lance le jeu
        api.getRandomSentence((data)=>{
            ga.sentences.push(...data);
            /*
                rajoute un peux de temps pour permettre de voir 
                le loading, si non dans certain cas, il apparès 
                durant une frame et ça rent male (je trouve)
            */
            setTimeout(()=>GamePageManager.changePage("GameCountDown"),400);
                
            api.getTopTen((data)=>{GameAdmin.instance.top10=data});
        });
    },[]);

    return (
        <div className="GamePage GameLoading">
            <h1>Loading...</h1>
        </div>
    );
}
